// attachmentChip.js — pure display data for a pending composer attachment.
//
// Sprint tier-s-chat E2-WS1-T02. Turns a raw attachment object (from
// useFileAttachments — { id, name, size, type, preview, kind, file }) into the
// flat shape the chip renders: name, size label, kind, ext label, thumbnail,
// a11y remove label. Keeps the component dumb and the logic testable. Reuses
// attachments.js (attachmentKind/extLabel) so there is one classification path.

import { attachmentKind, extLabel } from './attachments.js';

export function formatAttachmentSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function attachmentChipData(att) {
  const a = att || {};
  const file = a.file || {};
  const id = a.id ?? a.tempId ?? '';
  const name = a.name || a.filename || file.name || 'arquivo';
  const size = a.size ?? file.size ?? 0;
  const type = a.type || file.type || '';
  // `kind` may be precomputed by the hook; otherwise derive from the name.
  const kind = a.kind || (type.startsWith('image/') ? 'image' : attachmentKind(name));
  const thumbnailUrl = a.preview || a.thumbnailUrl || null;
  // An image only renders a thumbnail when we actually have the preview bytes;
  // otherwise fall back to the type icon so the chip never shows a broken img.
  const isImage = kind === 'image' && !!thumbnailUrl;
  return {
    id,
    name,
    type,
    kind,
    isImage,
    thumbnailUrl,
    sizeLabel: formatAttachmentSize(size),
    extLabel: extLabel(name),
    removeLabel: `Remover ${name}`,
  };
}
